export default function getFreshSideObject(){return{'top':0x0,'right':0x0,'bottom':0x0,'left':0x0};}